import { UseResource, useResource } from '../hooks/useResource';
import { QueryArgs, queryArgs } from '../utils/queryArgs';

export type GraphDataRetrieveQuery = {
  graph_type?: string;
};
export const graphDataRetrieveOperation = ({ graph_type, ...rest }: GraphDataRetrieveQuery) =>
  ({
    method: 'GET',
    path: `/dmx-server/orders/stats/${graph_type}/?${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'GET';
    path: string & { _templateUrl: '/dmx-server/orders/stats/' };
  };

export type GraphDataRetrieveResponse = {
  results: Record<string, string | number>[];
};

export const useGraphDataResource = (
  query: GraphDataRetrieveQuery | null,
  useCached?: boolean,
): UseResource<GraphDataRetrieveResponse> => {
  return useResource<GraphDataRetrieveResponse>({
    path: query === null ? null : graphDataRetrieveOperation(query).path,
    apiUrl: globalThis.DMX_CONFIG.server,
    useCached,
  });
};
